const lbNav = angular.module('app.lbNav', []);

if(process.env.APP_INITIAL === 'sct') {
  lbNav.controller('lbNavCtrl', require('../sct/sctNav/sctNavCtrl'));
  lbNav.component('lbNav', require('../sct/sctNav/sctNav'));
} else {
  lbNav.controller('lbNavCtrl', require('./lbNavCtrl'));
  lbNav.component('lbNav', require('./lbNav'));
}

export default lbNav;



// WEBPACK FOOTER //
// ./src/components/lbNav/index.js